import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="m17.552 2.66-1.87 1.872 4.242 4.242 1.871-1.87a3.42 3.42 0 0 0 .155-.966c.009-.667-.175-1.548-1.03-2.402-.855-.855-1.735-1.04-2.401-1.03a3.42 3.42 0 0 0-.966.155Zm5.104 4.797.91.413.002-.003.002-.005.006-.013a2.113 2.113 0 0 0 .062-.156 5.42 5.42 0 0 0 .312-1.729c.015-1.109-.316-2.543-1.616-3.843-1.3-1.3-2.734-1.63-3.843-1.615a5.421 5.421 0 0 0-1.729.312 3.312 3.312 0 0 0-.155.062l-.013.006-.005.002h-.003V.89c-.001 0-.002 0 .413.91l-.415-.91-.164.076L1.648 15.737l-.964 8.035 8.035-.964L23.491 8.036l.075-.165-.91-.414Zm-4.146 2.731-4.243-4.242L3.551 16.662l-.578 4.82 4.82-.578L18.51 10.188Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
